(ns arthur.domain.crc32
  "CRC-32, as PNG chunks and ZIP entries both define it.

  ONE implementation for both, and that is not premature sharing: a PNG chunk's
  trailing checksum and a ZIP local header's `crc-32` field are the same function
  of the same bytes — IEEE 802.3, reflected, with an initial and final complement
  — down to the polynomial. Two copies would be two chances to get the table
  wrong in a way that reads as \"the file is corrupt\" rather than as \"these two
  functions disagree\".

  It lives beside `domain/sha256` for the same reason that one does: a digest is
  a pure function of bytes with no DOM in it, so every assertion about it runs
  under node.")

(def ^:private table
  ;; The standard 256-entry table, built once. The bit-twiddling loop IS the
  ;; definition of the polynomial and there is no collection idiom hiding in it:
  ;; each entry is eight dependent shifts of one accumulator.
  (let [t (js/Uint32Array. 256)]
    (dotimes [n 256]
      (aset t n (loop [c n k 0]
                  (if (= k 8)
                    c
                    (recur (if (odd? c)
                             (bit-xor 0xedb88320 (unsigned-bit-shift-right c 1))
                             (unsigned-bit-shift-right c 1))
                           (inc k))))))
    t))

(defn of
  "CRC-32 of a byte array, or of the half-open range [from to) of one, as an
  unsigned 32-bit number.

  `loop` over the bytes rather than a reduce over a `range`: this walks the whole
  of every PNG written, which at 1920x1200 is seven megabytes a frame, and a seq
  cell per byte is the allocation the rest of this codebase is arranged to
  avoid."
  ([bytes] (of bytes 0 (.-length bytes)))
  ([bytes from to]
   (-> (loop [c 0xffffffff i from]
         (if (>= i to)
           c
           (recur (bit-xor (aget table (bit-and (bit-xor c (aget bytes i)) 0xff))
                           (unsigned-bit-shift-right c 8))
                  (inc i))))
       (bit-xor 0xffffffff)
       (unsigned-bit-shift-right 0))))
